import { render, staticRenderFns } from "./CityHousing.vue?vue&type=template&id=7947d648&"
import script from "./CityHousing.vue?vue&type=script&lang=js&"
export * from "./CityHousing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports